import React from "react";
import loadable from "@loadable/component";
import { Route } from "react-router-dom";
import { PageLoader } from "GlobalComponent/PageLoader";
import {
  NEWS_LISTING_ENDPOINT,
  REVIEWS_LISTING_ENDPOINT,
  SPECIAL_REPORTS_LISTING_ENDPOINT,
  IMAGES_LISTING_ENDPOINT,
  PIT_STOP_LISTING_ENDPOINT,
  VIDEOS_LISTING_ENDPOINT,
  HINDI_NEWS_LISTING_ENDPOINT,
  HINDI_EXPERT_REVIEW_LISTING_ENDPOINT,
  HINDI_FEATURES_LISTING_ENDPOINT,
  AUTOEXPO_NEWS_LISTING_ENDPOINT,
  PAGE_TYPE,
} from "../constants/GlobalListing";
import { deserialzeQueryStringToObject } from "GlobalUtils/Common";
import { isVernacularPage } from "GlobalUtils/Vernacular";
import { page } from "GlobalEnum/Page";
import { Pages } from "GlobalEnum/NewPage";

const EditorialListing = loadable(
  () =>
    import(
      /* webpackChunkName: "editoriallisting" */ "../containers/EditorialListing.js"
    ),
  {
    fallback: <PageLoader />,
  }
);

export const ArticlesListingRoute = [
  <Route
    exact
    path={NEWS_LISTING_ENDPOINT}
    exact
    key="news"
    render={props => {
      let pageType = PAGE_TYPE.NEWS_LISTING;
      if (isVernacularPage()) {
        pageType = PAGE_TYPE.HINDI_NEWS_LISTING;
      }
      return (
        <EditorialListing
          {...props}
          pageType={pageType}
          pageId={page.EDITORIAL_LISTING_PAGE_DESKTOP.id}
          newPageId={Pages.EDITORIAL_LISTING.id}
          isDesktop
        />
      );
    }}
  />,
  <Route
    exact
    path={REVIEWS_LISTING_ENDPOINT}
    key="expert-reviews"
    render={props => {
      let pageType = PAGE_TYPE.EXPERT_REVIEWS_LISTING;
      if (isVernacularPage()) {
        pageType = PAGE_TYPE.HINDI_EXPERT_REVIEW_LISTING;
      }
      return (
        <EditorialListing
          {...props}
          pageType={pageType}
          pageId={page.EDITORIAL_LISTING_PAGE_DESKTOP.id}
          newPageId={Pages.EDITORIAL_LISTING.id}
          isDesktop
        />
      );
    }}
  />,
  <Route
    exact
    key="special-report"
    path={SPECIAL_REPORTS_LISTING_ENDPOINT}
    render={props => {
      let pageType = PAGE_TYPE.FEATURE_LISTING;
      if (isVernacularPage()) {
        pageType = PAGE_TYPE.HINDI_FEATURES_LISTING;
      }
      return (
        <EditorialListing
          {...props}
          pageId={page.EDITORIAL_LISTING_PAGE_DESKTOP.id}
          newPageId={Pages.EDITORIAL_LISTING.id}
          pageType={pageType}
          isDesktop
        />
      );
    }}
  />,
  <Route
    exact
    key="iamges"
    path={IMAGES_LISTING_ENDPOINT}
    render={props => {
      const { match, location } = props;
      if (match && match.params && location && location.search) {
        const queryObj = deserialzeQueryStringToObject(location.search);
        if (queryObj) {
          const { make, model } = queryObj;
          if (make) {
            match.params.makeMaskingName = make;
          }
          if (model) {
            match.params.modelMaskingName = model;
          }
        }
        console.log("printing match from image, ", match);
      }
      return (
        <EditorialListing
          {...props}
          pageId={page.EDITORIAL_LISTING_PAGE_DESKTOP.id}
          newPageId={Pages.EDITORIAL_LISTING.id}
          pageType={PAGE_TYPE.IMAGES_LISTING}
          isDesktop
        />
      );
    }}
  />,
  <Route
    exact
    key="videos"
    path={VIDEOS_LISTING_ENDPOINT}
    render={props => {
      const { match, location } = props;
      if (match && match.params && location && location.search) {
        // adding model masking name in match.params as model is present in queryString.
        const queryObj = deserialzeQueryStringToObject(location.search);
        if (queryObj && queryObj.model) {
          match.params.modelMaskingName = queryObj.model;
        }
        console.log("printing match from videos end point, ", match);
      }
      return (
        <EditorialListing
          {...props}
          pageType={PAGE_TYPE.VIDEOS_LISTING}
          pageId={page.EDITORIAL_LISTING_PAGE_DESKTOP.id}
          newPageId={Pages.EDITORIAL_LISTING.id}
          isDesktop
        />
      );
    }}
  />,
  <Route
    path={HINDI_NEWS_LISTING_ENDPOINT}
    exact
    key="hindi-news"
    render={props => (
      <EditorialListing {...props} pageType={PAGE_TYPE.HINDI_NEWS_LISTING} />
    )}
  />,
  <Route
    path={PIT_STOP_LISTING_ENDPOINT}
    exact
    key="pit-stop"
    render={props => (
      <EditorialListing
        {...props}
        pageType={PAGE_TYPE.PIT_STOP_LISTING}
        pageId={page.EDITORIAL_LISTING_PAGE_DESKTOP.id}
        newPageId={Pages.EDITORIAL_LISTING.id}
        isDesktop
      />
    )}
  />,
  <Route
    path={HINDI_EXPERT_REVIEW_LISTING_ENDPOINT}
    exact
    key="hindi-expert-review"
    render={props => (
      <EditorialListing
        {...props}
        pageType={PAGE_TYPE.HINDI_EXPERT_REVIEW_LISTING}
        isDesktop
      />
    )}
  />,
  <Route
    key="hindi-features"
    path={HINDI_FEATURES_LISTING_ENDPOINT}
    exact
    render={props => (
      <EditorialListing
        {...props}
        pageType={PAGE_TYPE.HINDI_FEATURES_LISTING}
        isDesktop
      />
    )}
  />,
  <Route
    key="autoexpo"
    path={AUTOEXPO_NEWS_LISTING_ENDPOINT}
    exact
    render={props => (
      <EditorialListing
        {...props}
        pageType={PAGE_TYPE.AUTOEXPO_NEWS_LISTING}
        pageId={page.EDITORIAL_LISTING_PAGE_DESKTOP.id}
        newPageId={Pages.EDITORIAL_LISTING.id}
        isDesktop
      />
    )}
  />,
];
